import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function insigniaComboReducer(state= initialState.insigniaCombo, action){
	switch(action.type){
		case types.GET_INSIGNIAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}